/**
 * Tool result query operations - Update
 */

import { getSupabaseClient } from '../../supabase-client.js';
import type { StoredToolResultSummary } from '../types.js';
import { logger } from '../../../logger.js';

/**
 * Update a tool result
 */
export async function updateToolResult(
  toolResultId: string,
  updates: Partial<Omit<StoredToolResultSummary, 'id' | 'created_at'>>
): Promise<StoredToolResultSummary> {
  try {
    const client = getSupabaseClient();
    const now = new Date().toISOString();

    const { data, error } = await client
      .from('meridian_tool_results')
      .update({
        ...updates,
        updated_at: now,
      })
      .eq('id', toolResultId)
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data as StoredToolResultSummary;
  } catch (error) {
    logger.error('error updating tool result', error, { op: 'updateToolResult' });
    throw error;
  }
}
